import React from 'react';
import { useNavigate } from 'react-router-dom';
import elevateBg from './Elevate-Bg.png';
import './ReadyToElevate.css';

const ReadyToElevate = () => {
    const navigate = useNavigate();

    return (
        <section 
            className="ready-to-elevate-section"
            style={{ backgroundImage: `url(${elevateBg})` }}
        >
            <div className="elevate-overlay"></div>
            <div className="elevate-content">
                <h2>Ready to Elevate Your <br />Content ?</h2>
                <button 
                    className="elevate-quote-btn"
                    onClick={() => navigate('/editing-quote')}
                >
                    Get your Personalised Quote
                </button>
            </div>
        </section>
    );
};

export default ReadyToElevate;
